import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { AgendaUserType, GetAgendaUserQuery, GetAgendaUserQueryVariables, UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../graphql/API';
import { getAgendaUser, updateAgendaUser, usersByComId } from './queries';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Badge, Button, Col, Modal, Row, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom";
import Image from 'react-bootstrap/Image';
import Stack from 'react-bootstrap/Stack';
import { useTranslation } from 'react-i18next';
import UserImage from '../../components/UserImage';
import Sidebar from '../services/Sidebar/Sidebar';
import CustomModal from '../../components/Modals/CustomModal';
import axios from 'axios';
import { GiTrophy } from 'react-icons/gi';
import { IoMedal } from 'react-icons/io5';
import { FaMedal } from 'react-icons/fa6';
import { BsFillTrophyFill } from 'react-icons/bs';

const UsersView = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  // PARAMS
  const { id } = useParams<{ id: string }>();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);

  const {data: data, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser, fetchMore: fetchMoreUser} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: id}});

  const [doUpdateUser, {loading: loadingUpdate, error: errorUpdate}] = 
        useMutation<UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables>(updateAgendaUser); //data: dataUpdate, 

  useEffect(() => {
    document.title = t('title.user');
  }, []);

  const self = data?.getAgendaUser;
  const user = dataUser?.getAgendaUser;

  if (!self || !user) {
    // if (loading || loadingUsers || loadingShift) {
    // if (loading || loadingUsers || loadingShift || !users || !shifts) { // need to keep it like that to load all before the loading stop
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const promoteManagerEmployee = async () => {
    setShowCustomModal(false);
    // try {
    //   console.log("POST", email);
    //   const response = await axios.post("/api/get_manager", {
    //     email: email,
    //   });

    //   console.log("Get Work ComId:", response.data);
    //   return response.data; // Retourne le client token
    // } catch (error) {
    //   console.error("Error when getting worker comId :", error);
    //   return null;
    // }
    try {
      
        await doUpdateUser({variables: {input: {userId: user.userId, 
          type: user.type === "MANAGER" ?
            AgendaUserType.EMPLOYEE
          :
            AgendaUserType.MANAGER}}});
        refetchUser();
        // window.location.reload();
    } catch (error) {
        console.error("Update failed:", error);
    }
  };
  
  const askManager = () => {
    setFooterModal(false);
    setContentModal(
      <>
        <Modal.Header closeButton>
          <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{user.type == AgendaUserType.MANAGER ? t('profile.promoteEmployee') : t('profile.promoteManager')}</p>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
          Cancel
        </Button>
        <Button variant="primary" onClick={promoteManagerEmployee}>
          {t('home.apply')}
        </Button>
      </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };

    const workerSuspension = async () => {
    setShowCustomModal(false);
    try {
        await doUpdateUser({variables: {input: {userId: user.userId, 
          email: user.suspended ? user.email.slice(0, -"_suspended".length) : user.email + "_suspended",
          suspended: user.suspended ? false : true}}});
        refetchUser();
    } catch (error) {
        console.error("Update failed:", error);
    }
  };

  const askSuspension = () => {
    setFooterModal(false);
    setContentModal(
      <>
        <Modal.Header closeButton>
          <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{user.suspended ? t('profile.unsuspendWorker') : t('profile.suspendWorker')}</p>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
          Cancel
        </Button>
        { user.suspended ?
          <Button variant="success" onClick={workerSuspension}>
            {t('home.unsuspendNow')}
          </Button>
        :
          <Button variant="danger" onClick={workerSuspension}>
            {t('home.suspendNow')}
          </Button>
        }
      </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };
  // @ts-ignore
  const honorA = user?.honors?.items?.filter(h => h && h.type === "A"); 
  // @ts-ignore
  const honorB = user?.honors?.items?.filter(h => h && h.type === "B");
  // @ts-ignore
  const honorC = user?.honors?.items?.filter(h => h && h.type === "C");
  // @ts-ignore
  const honorD = user?.honors?.items?.filter(h => h && h.type === "D");
  return (
    <>
      <CustomModal
          show={showCustomModal}
          onHide={() => setShowCustomModal(false)}
          link={linkModal}
          children={contentModal}
          isFooter={footerModal}
      />
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
          <Row className="g-3 bg-white p-3 rounded-4 shadow-sm hover:shadow-md mt-2">
            {/* Première colonne : Photo et heures */}
            <Col xs={12} md={6} className="d-flex flex-column align-items-center w-100 border-bottom mt-2 pb-2">
              <Row className="text-end w-100">
                <div className="p-2 mb-4 d-inline-block">
                  <span style={{position: 'relative'}} title={t('shift.roundMedal')}>
                    <IoMedal
                      name={"medal"}
                      style={{color: '#FFD700', marginRight: 10, cursor: 'help'}}
                      size={30}
                    />
                    <Badge pill bg="dark" style={
                      honorD.length < 10 ? {position: 'absolute', top:-15, right: 17, fontSize: 8} :
                      honorD.length < 100 ? {position: 'absolute', top:-15, right: 15, fontSize: 8} :
                      {position: 'absolute', top:-15, right: 11, fontSize: 8}} >
                      {honorD.length}
                    </Badge>
                  </span>
                  <span style={{position: 'relative'}} title={t('shift.starMedal')}>
                    <FaMedal
                      name={"medal"}
                      style={{color: '#FFD700', marginRight: 10, cursor: 'help'}}
                      size={30}
                    />
                    <Badge pill bg="dark" style={
                      honorC.length < 10 ? {position: 'absolute', top:-15, right: 17, fontSize: 8} :
                      honorC.length < 100 ? {position: 'absolute', top:-15, right: 15, fontSize: 8} :
                      {position: 'absolute', top:-15, right: 11, fontSize: 8}} >
                      {honorC.length}
                    </Badge>
                  </span>
                  <span style={{position: 'relative'}} title={t('shift.trophy2')}>
                    <BsFillTrophyFill
                      name={"medal"}
                      style={{color: '#FFD700', marginRight: 10, cursor: 'help'}}
                      size={30}
                    />
                    <Badge pill bg="dark" style={
                      honorB.length < 10 ? {position: 'absolute', top:-15, right: 17, fontSize: 8} :
                      honorB.length < 100 ? {position: 'absolute', top:-15, right: 15, fontSize: 8} :
                      {position: 'absolute', top:-15, right: 11, fontSize: 8}} >
                      {honorB.length}
                    </Badge>
                  </span>
                  <span style={{position: 'relative'}} title={t('shift.trophy')}>
                    <GiTrophy
                      name={"medal"}
                      style={{color: '#FFD700', marginRight: 10, cursor: 'help'}}
                      size={30}
                    />
                    <Badge pill bg="dark" style={
                      honorA.length < 10 ? {position: 'absolute', top:-15, right: 17, fontSize: 8} :
                      honorA.length < 100 ? {position: 'absolute', top:-15, right: 15, fontSize: 8} :
                      {position: 'absolute', top:-15, right: 11, fontSize: 8}} >
                      {honorA.length}
                    </Badge>
                  </span>
                </div>
              </Row>
              <Row>
                <Col className="d-flex flex-column">
                  <div className="p-2">
                    <UserImage user={user} customClass="userImage_lg shadow-sm hover:shadow-md" key={"worker_" + user.userId} />
                  </div>
                </Col>
                <Col className="d-flex flex-column">
                  <div className="p-2">
                    <p>{t('user.username')}: {user.username}</p>
                    <p>{t('user.email')}: {user.email}</p>
                  </div>

                  {/* <div className="p-2">
                    <Link to={`/shifts/${user.userId}`}>{t('profile.shifts')}</Link>
                  </div> */}

                  { self.type === "MANAGER" &&
                    <div className="p-2">
                      <Link to="" onClick={() => askManager()}>{
                        user.type === "MANAGER" ? 
                          user.userId !== AuthUserId &&
                            t('profile.becomeEmployee')
                        : 
                          t('profile.becomeManager')
                      }</Link>
                    </div>
                  }
                  { self.type === "MANAGER" &&
                    <div className="p-2">
                      <Link to={`${t('link.worker')}/${user.userId}/documents`}>{t('navBar.documents')}</Link>
                    </div>
                  }

                  { self.type === "MANAGER" &&
                    
                    <div className="p-2">
                        {user.suspended ?
                          <Button variant="success" onClick={askSuspension}>{t('navBar.unsuspendUser')}</Button>
                        :
                          <Button variant="danger" onClick={askSuspension}>{t('navBar.suspendUser')}</Button>
                        }
                    </div>
                  }
                </Col>
              </Row>
            </Col>
            <Col xs={12} md={6} className="d-flex flex-column align-items-center w-100">
          
              <Row className="p-2 d-flex flex-row justify-content-between">
                <Col className="d-flex flex-column text-start me-3">
                  <p>{t('user.hours')}: </p>
                  <p>{t('user.night')}: </p>
                  <p>{t('user.monday')}: </p>
                  <p>{t('user.tuesday')}: </p>
                  <p>{t('user.thursday')}: </p>
                  <p>{t('user.wednesday')}: </p>
                  <p>{t('user.friday')}: </p>
                  <p>{t('user.saturday')}: </p>
                  <p>{t('user.sunday')}: </p>
                  {user?.type === "MANAGER" && (
                    <p style={{whiteSpace: 'nowrap'}}>{t('user.isConfirmed')}: </p>
                  )}
                </Col>

                <Col className="d-flex flex-column text-end me-3">
                  <p>{user.hours ? user.hours : 0}</p>
                  <p>{user.night ? "🟢" : "🔴"}</p>
                  <p>{user.monday ? "🟢" : "🔴"}</p>
                  <p>{user.tuesday ? "🟢" : "🔴"}</p>
                  <p>{user.wednesday ? "🟢" : "🔴"}</p>
                  <p>{user.thursday ? "🟢" : "🔴"}</p>
                  <p>{user.friday ? "🟢" : "🔴"}</p>
                  <p>{user.saturday ? "🟢" : "🔴"}</p>
                  <p>{user.sunday ? "🟢" : "🔴"}</p>
                  {user?.type === "MANAGER" && (
                    <p >{user.isConfirmed ? "🟢" : "🔴"}</p>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default UsersView;


